import { cn } from '@costar-ui/cosmos'
import React from 'react'

import type { HeadCellProps } from './types'

const HeadCell = React.forwardRef<HTMLTableCellElement, HeadCellProps>(
  ({ className, ...props }, ref) => {
    return (
      <th
        ref={ref}
        className={cn(
          'csg-tw-table-head-cell relative bg-neutral-light px-4 py-1 text-left font-bold text-primary',
          className
        )}
        {...props}
      />
    )
  }
)

HeadCell.displayName = 'HeadCell'

export default HeadCell
